var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingQuestionIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1C6.15684 1 1 6.15684 1 12.5C1 18.8432 6.15684 24 12.5 24C18.8432 24 24 18.8432 24 12.5C24 6.15684 18.8432 1 12.5 1ZM4.92211 12.5C4.92211 11.1199 5.30951 9.83676 5.93895 8.7232L16.2768 19.0611C15.1631 19.7148 13.88 20.0779 12.5 20.0779C8.31167 20.0779 4.92211 16.6883 4.92211 12.5ZM19.0611 16.2768L8.72316 5.9389C9.83693 5.28518 11.12 4.92206 12.5 4.92206C16.6883 4.92206 20.0779 8.31145 20.0779 12.5C20.0779 13.88 19.6905 15.1632 19.0611 16.2768Z",
    fill: "#E1755C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingQuestionIcon2);
export default __webpack_public_path__ + "static/media/landing_question_icon2.f59d0ad167a3d904118c3ab500725362.svg";
export { ForwardRef as ReactComponent };